export default {
  "account": {
    "curatedCollections": "Kuratierte Sammlungen",
    "curatedCollectionsInfo": "Hier finden Sie alle Sammlungen, die Sie kuratiert haben",
    "editProfile": "Profil bearbeiten",
    "likes": "Likes",
    "linkAccount": "Mein Konto",
    "linkLogin": "Anmelden",
    "linkLoginJoin": "Anmelden/Beitreten",
    "linkLogout": "Abmelden",
    "myProfile": "Mein Profil",
    "notifications": {
      "loggedIn": "Sie sind jetzt eingeloggt. Willkommen!",
      "loggedOut": "Sie sind jetzt ausgeloggt.",
      "noCollections": {
        "curated": "Sie haben noch keine Sammlungen kuratiert",
        "private": "Sie haben bisher keine private Galerie erstellt",
        "public": "Sie haben bisher keine öffentliche Galerie erstellt"
      },
      "noLikedItems": "Sie haben bisher keine Objekte mit einem Like versehen"
    },
    "privateCollections": "Private Galerien",
    "profile": "Meine Likes & Galerien",
    "profileSettings": "Profileinstellungen",
    "publicCollections": "Öffentliche Galerien",
    "settings": "Einstellungen",
    "title": "Mein Konto"
  },
  "actions": {
    "accept": "Akzeptieren",
    "cancel": "Abbrechen",
    "close": "schließen",
    "continue": "Fortfahren",
    "download": "Herunterladen",
    "edit": "Bearbeiten",
    "feedback": "Feedback",
    "goBack": "Zurückgehen",
    "goHome": "Zur Homepage gehen",
    "learnMore": "Mehr erfahren",
    "like": "Like",
    "move": "Verschieben",
    "next": "Weiter",
    "pin": "Stift",
    "preview": "Vorschau",
    "previous": "Vorherige",
    "providedBy": "Bereitgestellt von {provider}",
    "reject": "Ablehnen",
    "save": "Speichern",
    "send": "Senden",
    "share": "Teilen",
    "shareOn": "Teilen auf {social}",
    "skip": "Überspringen",
    "viewAt": "Ansicht unter {link}",
    "viewDocument": "Dokument anzeigen"
  },
  "attribution": {
    "country": "Land:",
    "creator": "Urheber:",
    "date": "Datum:",
    "institution": "Institution:",
    "title": "Titel:"
  },
  "automatedCardGroup": {
    "item": "Aktuelle Objekte",
    "organisation": "Organisationen",
    "place": "Orte",
    "time": "Ausgewählte Jahrhunderte",
    "topic": "Ausgewählte Themen"
  },
  "blog": {
    "author": "Autor",
    "authors": "Autoren",
    "blog": "Blog",
    "by": "von",
    "categories": "Kategorien",
    "category": "Kategorie",
    "posts": "Blog-Beiträge",
    "published": "Veröffentlicht am {date}",
    "relatedPosts": "Ähnliche Beiträge"
  },
  "cardLabels": {
    "organisation": "Organisation",
    "person": "Person",
    "place": "Ort",
    "theme": "Thema",
    "time": "Jahrhundert",
    "topic": "Thema"
  },
  "clearAllFilters": "Alle Filter löschen",
  "collections": {
    "actions": {
      "edit": "Sammlung bearbeiten",
      "update": "Sammlung aktualisieren"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "Designer",
          "name": "Designer | Designer",
          "select": "Designer auswählen"
        },
        "proxy_dc_format": {
          "moreName": "Techniken",
          "name": "Technik | Techniken",
          "select": "Techniken auswählen"
        },
        "proxy_dc_type": {
          "moreName": "Objekttypen",
          "name": "Objekttyp | Objekttypen",
          "select": "Objekttypen auswählen"
        },
        "proxy_dcterms_medium": {
          "moreName": "Materialien",
          "name": "Material | Materialien",
          "select": "Materialien auswählen"
        }
      }
    },
    "form": {
      "description": "Beschreibung"
    },
    "notifications": {
      "update": "Die Kollektion wurde aktualisiert"
    }
  },
  "collectionsYouMightLike": "Kollektionen, die Ihnen gefallen könnten",
  "colourSwatch": "Farbmuster",
  "contentYouMightLike": "Inhalte, die Ihnen gefallen könnten",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Mehr Infos",
      "about": "Über Europeana",
      "forDevelopers": "Für Entwickler",
      "help": "Hilfe",
      "meetUs": "Lernen Sie das Team kennen",
      "provide": "Werden Sie Datenanbieter",
      "subscribe": "Abonnieren Sie unseren Newsletter",
      "terms": "Nutzungsbedingungen und Datenschutzerklärung"
    },
    "headerNavigation": {
      "Collections": "Kollektionen",
      "explore": "Erkunden",
      "teachers": "Lehrerinnen und Lehrerinnen"
    }
  },
  "curatedAutomatically": "Automatisch von Europeana kuratiert",
  "dateFilter": {
    "endDate": "Enddatum",
    "specificDate": "Bestimmtes Datum",
    "startDate": "Anfangsdatum",
    "to": "an"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana-API-Schlüssel",
      "noRequests": "Auf dieser Seite wurden keine Anfragen an Europeana-APIs verwendet.",
      "settingsPageLinkText": "Einstellungsseite",
      "tip": "Tipp: Wenn Sie bereits einen {apiKeyLink} haben, können Sie ihn auf dem {settingsPageLink} eingeben und er wird in diese API-Anforderungslinks aufgenommen.",
      "title": "API-Anfragen"
    },
    "debug": "Debuggen",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Geben Sie Ihren Europeana-API-Schlüssel ein und er wird in den Links zu API-Anfragen verwendet.",
          "label": "API-Schlüssel"
        },
        "enabled": {
          "description": "Wenn aktiviert, wird das Debug-Menü in der Fußzeile der Seite angezeigt.",
          "label": "Debug-Menü aktivieren"
        }
      },
      "title": "Einstellungen"
    }
  },
  "delete": "Löschen",
  "depiction": "Eine Darstellung von {title}",
  "directions": {
    "left": "Links",
    "right": "Rechts"
  },
  "edmIsShownAtLinkAlt": "Auf der Website des Anbieters ansehen",
  "entity": {
    "actions": {
      "cancel": "Abbrechen",
      "pin": "Objekt anheften",
      "unpin": "Objekt loslösen",
      "viewPinned": "Angepinnte Objekte ansehen"
    },
    "labels": {
      "entity": "Entität"
    },
    "notifications": {
      "deleted": "Ihre Galerie wurde gelöscht.",
      "error": {
        "unpin": "Beim Lösen des Elements ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder melden Sie das Problem."
      },
      "pin": "Dieses Objekt wird oben in der Auflistung \"{entity}\" angezeigt. Wir werden Sie benachrichtigen, wenn diese Änderung auf der Sammlungsseite sichtbar wird.",
      "pinLimit": {
        "body": "Zurzeit können Sie nur 24 Objekte auf der ersten Seite pinnen. Wenn Sie dieses Objekt pinnen möchten, müssen Sie erst einen anderen Objekt entpinnen und dann versuchen, dieses Objekt erneut zu pinnen.",
        "title": "Zu viele angeheftete Objekte"
      },
      "pinned": "Das Objekt wurde angeheftet. Es befindet sich jetzt oben auf der ersten Seite dieser Sammlung. Es kann bis zu 24 Stunden dauern, bis es für alle erscheint.",
      "select": "Wählen Sie eine zugehörige Entität aus, um das Objekt daran anzuheften/von ihr zu lösen.",
      "unpin": "Dieses Objekt wird nicht mehr oben in der Sammlung „ {entity} “ angezeigt. Wir werden Sie benachrichtigen, wenn diese Änderung auf der Sammlungsseite sichtbar wird.",
      "unpinned": "Das Objekt wurde nicht mehr angepinnt. Es steht nicht mehr oben auf der ersten Seite dieser Sammlung. Es kann bis zu 24 Stunden dauern, bis es für alle verschwindet."
    }
  },
  "error": "Fehler",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Dies ist nicht möglich, da private Galerien nur für ihren Ersteller sichtbar sind. Wenn Sie den Ersteller der Galerie kennen, bitten Sie ihn, die Galerie öffentlich zu machen. Alternativ können Sie dieses Problem auch über die Feedback-Schaltfläche melden.",
      "metaTitle": "Galerie nicht autorisiert",
      "title": "Oops! {newline} Sie versuchen, die private Galerie einer anderen Person anzuzeigen."
    },
    "itemNotFound": {
      "description": "Dies kann folgende Gründe haben: Diesem Objekt existiert nicht oder; es wurde depubliziert, weil es nicht unseren Qualitätskriterien entsprach, oder; Es wurde aktualisiert und mit einer neuen eindeutigen Kennung erneut veröffentlicht. Versuchen Sie in diesem Fall, das Objekt erneut zu finden.",
      "metaTitle": "Objekt nicht gefunden",
      "title": "Ach nein! {newline} Wir konnten dies Objekt nicht finden."
    }
  },
  "exhibitions": {
    "chapters": "Kapitel",
    "credits": "Credits",
    "currentChapter": "Aktuelles Kapitel",
    "description": "Entdecken Sie die Ausstellungen",
    "exhibitions": "Ausstellungen"
  },
  "explore": "Erforschen",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "Farben",
      "name": "Farbe | Farben",
      "options": {
        "#000000": "Schwarz",
        "#000080": "Navy blau",
        "#00008B": "Dunkelblau",
        "#0000CD": "Mittelblau",
        "#0000FF": "Blau",
        "#006400": "Dunkelgrün",
        "#008000": "Web Green",
        "#008080": "Blaugrün",
        "#008B8B": "Dunkler Cyan",
        "#00BFFF": "Tiefes Himmelblau",
        "#00CED1": "Dunkles Türkis",
        "#00FA9A": "Mittleres Frühlingsgrün",
        "#00FF00": "Grün",
        "#00FF7F": "Frühlingsgrün",
        "#00FFFF": "Cyan",
        "#191970": "Mitternachtsblau",
        "#1E90FF": "Schwarzblau",
        "#20B2AA": "Helles Seegrün",
        "#228B22": "Waldgrün",
        "#2E8B57": "Meeresgrün",
        "#2F4F4F": "Dunkles Schiefergrau",
        "#32CD32": "Limonengrün",
        "#3CB371": "Mittleres Seegrün",
        "#40E0D0": "Türkis",
        "#4169E1": "Königsblau",
        "#4682B4": "Stahlblau",
        "#483D8B": "Dunkles Schieferblau",
        "#48D1CC": "Mittleres Türkis",
        "#4B0082": "Indigo",
        "#556B2F": "Dunkles Olivgrün",
        "#5F9EA0": "Kadettenblau",
        "#6495ED": "Kornblume",
        "#663399": "Rebecca Lila",
        "#66CDAA": "Mittlerer Aquamarin",
        "#696969": "Dim Grey",
        "#6A5ACD": "Schieferblau",
        "#6B8E23": "Olivgrün",
        "#708090": "Schiefergrau",
        "#778899": "Helles Schiefergrau",
        "#7B68EE": "Mittleres Schieferblau",
        "#7CFC00": "Rasengrün",
        "#7F0000": "Web Maroon",
        "#7F007F": "Web Lila",
        "#7FFF00": "Chartreuse",
        "#7FFFD4": "Aquamarin",
        "#800000": "Kastanienbraun",
        "#800080": "Lila",
        "#808000": "Olive",
        "#808080": "Web Grey",
        "#87CEEB": "Himmelblau",
        "#87CEFA": "Helles Himmelblau",
        "#8A2BE2": "Blau Violett",
        "#8B0000": "Dunkelrot",
        "#8B008B": "Dunkles Magenta",
        "#8B4513": "Sattelbraun",
        "#8FBC8F": "Dunkelmeergrün",
        "#90EE90": "Hellgrün",
        "#9370DB": "Mittel Lila",
        "#9400D3": "Dunkelviolett",
        "#98FB98": "Blasses Grün",
        "#9932CC": "Dunkle Orchidee",
        "#9ACD32": "Gelbgrün",
        "#A020F0": "Lila",
        "#A0522D": "Erdfarben",
        "#A52A2A": "Braun",
        "#A9A9A9": "Dunkelgrau",
        "#ADD8E6": "Hellblau",
        "#ADFF2F": "Grün Gelb",
        "#AFEEEE": "Blasses Türkis",
        "#B03060": "Kastanienbraun",
        "#B0C4DE": "Helles Stahlblau",
        "#B0E0E6": "Puderblau",
        "#B22222": "Schamottestein",
        "#B8860B": "Dunkle Goldrute",
        "#BA55D3": "Mittlere Orchidee",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Dunkles Khaki",
        "#BEBEBE": "Grau",
        "#C0C0C0": "Silber",
        "#C71585": "Mittelviolettrot",
        "#CD5C5C": "Indisches Rot",
        "#CD853F": "Peru",
        "#D2691E": "Schokolade",
        "#D2B48C": "Bräunen",
        "#D3D3D3": "Hellgrau",
        "#D8BFD8": "Distel",
        "#DA70D6": "Orchidee",
        "#DAA520": "Goldrute",
        "#DB7093": "Hellviolettrot",
        "#DC143C": "Karminrot",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Pflaume",
        "#DEB887": "Kräftiges Holz",
        "#E0FFFF": "Leichtes Cyan",
        "#E6E6FA": "Lavendel",
        "#E9967A": "Dunkler Lachs",
        "#EE82EE": "Violett",
        "#EEE8AA": "Blasse Goldrute",
        "#F08080": "Helles Koralle",
        "#F0E68C": "Khaki",
        "#F0F8FF": "Alice Blau",
        "#F0FFF0": "Honigtau",
        "#F0FFFF": "Azurblau",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Weizen",
        "#F5F5DC": "Beige",
        "#F5F5F5": "Weißer Rauch",
        "#F5FFFA": "Minzcreme",
        "#F8F8FF": "Ghost White",
        "#FA8072": "Lachs",
        "#FAEBD7": "Altweiß",
        "#FAF0E6": "Leinen",
        "#FAFAD2": "Leichte Goldrute",
        "#FDF5E6": "Alte Spitze",
        "#FF0000": "rot",
        "#FF00FF": "Fuchsie",
        "#FF1493": "Tiefes Pink",
        "#FF4500": "Orange Rot",
        "#FF6347": "Tomate",
        "#FF69B4": "Hot Pink",
        "#FF7F50": "Koralle",
        "#FF8C00": "Dunkelorange",
        "#FFA07A": "Helles Lachs",
        "#FFA500": "Orange",
        "#FFB6C1": "Hell-Pink",
        "#FFC0CB": "Rosa",
        "#FFD700": "Gold",
        "#FFDAB9": "Pfirsichhauch",
        "#FFDEAD": "Navajo Weiß",
        "#FFE4B5": "Mokassin",
        "#FFE4C4": "Biskuit",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Blanchierte Mandel",
        "#FFEFD5": "Papaya Peitsche",
        "#FFF0F5": "Lavendel erröten",
        "#FFF5EE": "Muschel",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Zitronen-Chiffon",
        "#FFFAF0": "Blumenweiß",
        "#FFFAFA": "Schnee",
        "#FFFF00": "Gelb",
        "#FFFFE0": "Hellgelb",
        "#FFFFF0": "Elfenbein",
        "#FFFFFF": "Weiß"
      },
      "select": "Farben auswählen"
    },
    "COUNTRY": {
      "name": "Bereitstellendes Land",
      "options": {
        "Albania": "Albanien",
        "Austria": "Österreich",
        "Belarus": "Belarus",
        "Belgium": "Belgien",
        "Bosnia and Herzegovina": "Bosnien und Herzegowina",
        "Bulgaria": "Bulgarien",
        "Croatia": "Kroatien",
        "Cyprus": "Zypern",
        "Czech Republic": "Tschechische Republik",
        "Denmark": "Dänemark",
        "Estonia": "Estland",
        "Europe": "Europa",
        "Finland": "Finnland",
        "France": "Frankreich",
        "Georgia": "Georgien",
        "Germany": "Deutschland",
        "Greece": "Griechenland",
        "Holy See (Vatican City State)": "Heiliger Stuhl (Staat Vatikanstadt)",
        "Hungary": "Ungarn",
        "Iceland": "Island",
        "Ireland": "Irland",
        "Israel": "Israel",
        "Italy": "Italien",
        "Latvia": "Lettland",
        "Lithuania": "Litauen",
        "Luxembourg": "Luxemburg",
        "Macedonia": "Mazedonien",
        "Malta": "Malta",
        "Moldova": "Moldawien",
        "Montenegro": "Montenegro",
        "Netherlands": "Niederlande",
        "Norway": "Norwegen",
        "Poland": "Polen",
        "Portugal": "Portugal",
        "Romania": "Rumänien",
        "Russia": "Russland",
        "Serbia": "Serbien",
        "Slovakia": "Slowakei",
        "Slovenia": "Slowenien",
        "Spain": "Spanien",
        "Sweden": "Schweden",
        "Switzerland": "Schweiz",
        "Turkey": "Turkei",
        "Ukraine": "Ukraine",
        "United Kingdom": "Vereinigtes Königreich",
        "United States of America": "Vereinigte Staaten von Amerika"
      },
      "select": "Bereitstellende Länder auswählen"
    },
    "CREATOR": {
      "moreName": "Ersteller",
      "name": "Ersteller | Ersteller",
      "select": "Ersteller auswählen"
    },
    "DATA_PROVIDER": {
      "moreName": "Institutionen",
      "name": "Institution | Institutionen",
      "select": "Institutionen auswählen"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Bildausrichtung | Bildausrichtungen",
      "options": {
        "landscape": "Querformat",
        "portrait": "Hochformat"
      },
      "select": "Bildausrichtungen auswählen"
    },
    "IMAGE_SIZE": {
      "name": "Bildgröße | Bildgrößen",
      "options": {
        "extra_large": "Extra große 4MP+ (z.B. 2688 x 1520px)",
        "large": "Große 1-4MP (z. B. 1920x1080px)",
        "medium": "Mittel 0,5-1 MP (z. B. 850 x 850 Pixel)",
        "small": "Klein < 0,5 MP (z. B. 650 x 600 Pixel)"
      },
      "select": "Bildgrößen auswählen"
    },
    "LANGUAGE": {
      "name": "Sprache | Sprachen",
      "options": {
        "ar": "Arabisch",
        "bg": "Bulgarisch",
        "bs": "Bosnisch",
        "ca": "Katalanisch",
        "cs": "Tschechisch",
        "cy": "Walisisch",
        "da": "Dänisch",
        "de": "Deutsch",
        "el": "Griechisch",
        "en": "Englisch",
        "es": "Spanisch",
        "et": "Estnisch",
        "fi": "Finnisch",
        "fr": "Französisch",
        "ga": "Irisch",
        "gd": "Gälisch",
        "he": "Hebräisch",
        "hr": "Kroatisch",
        "hu": "Ungarisch",
        "is": "Isländisch",
        "it": "Italienisch",
        "lt": "Litauisch",
        "lv": "Lettisch",
        "mk": "Mazedonisch",
        "mt": "Maltesisch",
        "mul": "Mehrere Sprachen",
        "nl": "Niederländisch",
        "no": "Norwegisch",
        "pl": "Polnisch",
        "pt": "Portugiesisch",
        "ro": "Rumänisch",
        "ru": "Russisch",
        "sk": "Slowakisch",
        "sl": "Slowenisch",
        "sq": "Albanisch",
        "sr": "Serbisch",
        "sv": "Schwedisch",
        "tr": "Türkisch",
        "uk": "Ukrainisch"
      },
      "select": "Sprachen auswählen"
    },
    "MIME_TYPE": {
      "name": "Dateiformat | Dateiformate",
      "options": {
        "text/plain": "Klartext"
      },
      "select": "Dateiformate auswählen"
    },
    "PROVIDER": {
      "moreName": "Aggregatoren",
      "name": "Aggregator | Aggregatoren",
      "select": "Aggregatoren auswählen"
    },
    "REUSABILITY": {
      "name": "Kann ich es wiederverwenden?",
      "options": {
        "open": "Ja",
        "permission": "Vielleicht, bitten Sie um Erlaubnis",
        "restricted": "Ja, mit Bedingungen",
        "uncategorized": "Nicht kategorisiert"
      },
      "select": "Wählen Sie aus, ob die Objekte wiederverwendbar sind"
    },
    "TYPE": {
      "name": "Art des Mediums",
      "options": {
        "3D": "3D",
        "IMAGE": "Bild",
        "SOUND": "Ton",
        "TEXT": "Text",
        "VIDEO": "Video"
      },
      "select": "Medientypen auswählen"
    },
    "api": {
      "name": "Suche nach",
      "options": {
        "fulltext": "Aufzeichnungen mit Volltext",
        "metadata": "Nur-Metadaten Aufzeichnungen"
      },
      "switch": "Suchen Sie nur im Inhalt von Artikeln mit Volltext",
      "switchMoreInfo": "In dieser Sammlung können Sie auswählen, wonach Sie suchen möchten: Wenn dieser Schalter eingeschaltet ist, suchen Sie innerhalb des Zeitungs- und Dokumententextes; Wenn es deaktiviert ist, suchen Sie stattdessen in den Informationen, die das Element beschreiben, so wie Sie es in den meisten anderen Sammlungen immer tun."
    },
    "button": {
      "apply": "Anwenden",
      "cancel": "Abbrechen",
      "morefilters": "Weitere Filter",
      "reset": "Zurücksetzen",
      "showAll": "Alle {label} anzeigen",
      "showLess": "Weniger anzeigen {label}"
    },
    "collection": {
      "name": "Thema",
      "options": {
        "archaeology": "Archäologie",
        "art": "Kunst",
        "fashion": "Mode",
        "industrial": "Industrielles Erbe",
        "manuscript": "Manuskripte",
        "map": "Karten und Geographie",
        "migration": "Migration",
        "music": "Musik",
        "nature": "Naturgeschichte",
        "newspaper": "Zeitungen",
        "photography": "Fotografie",
        "sport": "Sport",
        "ww1": "Erster Weltkrieg"
      },
      "select": "Ein thema auswählen"
    },
    "contentTier": {
      "name": "Objektqualität",
      "options": {
        "*": "Enthält Objekte, die nicht unseren Veröffentlichungskriterien entsprechen",
        "0": "Nur Objekte anzeigen, die unsere Veröffentlichungskriterien nicht erfüllen",
        "1": "Geringe Qualität",
        "2": "Mittlere Qualität",
        "3": "Hohe Qualität & wiederverwendbar mit Bedingungen",
        "4": "Hohe Qualität & frei wiederverwendbar"
      },
      "select": "Objektqualitäten auswählen"
    },
    "moreOptions": "Suchen, um {0} mehr {1} zu finden.",
    "proxy_dc_format": {
      "name": "Format | Formate",
      "select": "Formate auswählen"
    },
    "proxy_dc_type": {
      "name": "Typ | Typen",
      "select": "Typen auswählen"
    },
    "proxy_dcterms_issued": {
      "name": "Ausstellungsdatum"
    },
    "proxy_dcterms_medium": {
      "name": "Medium | Medien",
      "select": "Medien auswählen"
    }
  },
  "feedback": {
    "emailOptional": "Möglicherweise möchten wir nachfassen. Geben Sie Ihre E-Mail-Adresse ein, wenn Sie damit einverstanden sind, dass wir Sie kontaktieren.",
    "failed": "Die Anfrage ist fehlgeschlagen. Bitte versuche es erneut.",
    "form": {
      "placeholders": {
        "email": "Geben sie ihre E-Mailadresse ein",
        "feedback": "Geben Sie hier Ihr Feedback ein"
      }
    },
    "policies": "Indem Sie fortfahren, stimmen Sie unseren {0} und erkennen unsere {1} .",
    "privacyPolicy": "Datenschutz-Bestimmungen",
    "success": "Ihr Feedback wurde gesendet.",
    "termsOfService": "Nutzungsbedingungen",
    "thankYou": "Vielen Dank!",
    "title": "Feedback abschicken",
    "validEmail": "Geben Sie eine gültige E-Mail Adresse ein",
    "validFeedback": "Ihr Feedback muss aus mindestens 5 Wörtern bestehen"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Mitwirkende",
      "dcCoverage": "Ort-Zeit",
      "dcCreator": "Urheber",
      "dcDate": "Datum",
      "dcDescription": "Beschreibung",
      "dcDuration": "Dauer",
      "dcFormat": "Format",
      "dcIdentifier": "Kennung",
      "dcLanguage": "Sprache",
      "dcPublisher": "Herausgeber",
      "dcRelation": "Beziehungen",
      "dcRights": "Rechte",
      "dcSource": "Quelle",
      "dcSubject": "Betreff",
      "dcTitle": "Titel",
      "dcType": "Art des Objekts",
      "dctermsCreated": "Erstellungsdatum",
      "dctermsExtent": "Umfang",
      "dctermsHasPart": "Besteht aus",
      "dctermsHasVersion": "Hat Version",
      "dctermsIsFormatOf": "Ist das Format von",
      "dctermsIsPartOf": "Ist ein Teil von",
      "dctermsIsReferencedBy": "Wird referenziert von",
      "dctermsIsReplacedBy": "Wird ersetzt durch",
      "dctermsIsRequiredBy": "Wird benötigt von",
      "dctermsIssued": "Ausgabedatum",
      "dctermsMedium": "Medium",
      "dctermsProvenance": "Herkunft",
      "dctermsReferences": "Verweisen auf",
      "dctermsSpatial": "Orte",
      "dctermsTOC": "Inhaltsverzeichnis",
      "dctermsTemporal": "Zeitlich",
      "edmCountry": "Bereitstellendes Land",
      "edmCurrentLocation": "Aktueller Standort",
      "edmDataProvider": "Bereitstellende Institution",
      "edmHasMet": "Hat getroffen",
      "edmIncorporates": "Einbeziehen",
      "edmIntermediateProvider": "Zwischenanbieter",
      "edmIsDerivativeOf": "Ist eine Weiterentwicklung von",
      "edmIsRelatedTo": "Ist verwandt mit",
      "edmIsRepresentationOf": "Ist die Darstellung von",
      "edmIsSimilarTo": "Ist ähnlich wie",
      "edmIsSuccessorOf": "Ist Nachfolger von",
      "edmProvider": "Anbieter",
      "edmRealizes": "Realisiert",
      "edmRights": "Lizenz der Medien in diesem Datensatz (sofern nicht anders angegeben)",
      "edmUgc": "Benutzergenerierte Inhalte",
      "europeanaCollectionName": "Name der Sammlung",
      "keywords": "Schlüsselwörter (von der Gemeinschaft zur Verfügung gestellt)",
      "timestampCreated": "Zeitstempel erstellt",
      "timestampUpdate": "Zeitstempel aktualisiert",
      "wasPresentAt": "War anwesend bei",
      "year": "Jahr"
    },
    "webResource": {
      "about": "RDF Über",
      "dcDescription": "Beschreibung",
      "ebucoreHasMimeType": "Ebucore MIME-Typ",
      "edmRights": "Lizenz für diese Medienressource",
      "rdfAbout": "RDF Über"
    }
  },
  "filter": "Filter",
  "filterResults": "Filter Ergebnisse",
  "footer": {
    "customiseWebsiteLanguage": "Sprache der Website anpassen",
    "disclaimerLine1": "Europeana ist eine Initiative der Europäischen Union, die von der \"Connecting Europe Facility“ der Europäischen Union und den Mitgliedstaaten der Europäischen Union finanziert wird. Die Europeana-Dienste, einschließlich dieser Website, werden von einem Konsortium betrieben, das von der Europeana Foundation im Rahmen eines Dienstleistungsvertrags mit der Europäischen Kommission geführt wird.",
    "disclaimerLine2": "Die Europäische Kommission übernimmt keine Gewähr für die Richtigkeit der Informationen und übernimmt keinerlei Verantwortung oder Haftung für die Informationen auf dieser Website. Weder die Europäische Kommission noch eine Person, die im Namen der Europäischen Kommission handelt, ist für die Richtigkeit oder Verwendung der Informationen auf dieser Website verantwortlich oder haftbar.",
    "findUsElsewhere": "Finden Sie uns anderswo",
    "imageDescription": "Finanziert von der Europäischen Union",
    "navigation": {
      "MoreInfoLabel": "Mehr Infos",
      "about": "Über uns",
      "accessibility": "Barrierefreiheit",
      "cookies": "Cookies",
      "forDevelopers": "Für Entwickler",
      "help": "Hilfe",
      "privacy": "Datenschutz-Bestimmungen",
      "provide": "Werden Sie Datenanbieter",
      "subscribe": "Abonnieren Sie unseren Newsletter",
      "terms": "Nutzungsbedingungen"
    },
    "ourMission": "Unser Auftrag",
    "ourMissionQuote": "Europeana befähigt den Sektor des kulturellen Erbes bei seiner digitalen Transformation. Wir entwickeln Fachwissen, Tools und Richtlinien, um den digitalen Wandel zu nutzen und Partnerschaften zu fördern, die Innovationen fördern."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Erkunden Sie unsere Galerien",
    "galleries": "Galerien"
  },
  "goToRecord": "Zur Aufnahme gehen",
  "header": {
    "backToMenu": "Suchfeld schließen",
    "clearQuery": "Suchanfrage löschen",
    "closeSidebar": "Menü schließen",
    "entireCollection": "Suchen Sie nach {query} in unserer gesamten Kollektion",
    "europeanaHome": "Europeana-Startseite",
    "inCollection": "Suchen Sie nach {query} in {collection}",
    "navigation": {
      "about": "Über uns",
      "collections": "Sammlungen",
      "europeanaClassroom": "Für Lehrer",
      "help": "Hilfe",
      "home": "Startseite",
      "pro": "Für Fachleute",
      "stories": "Geschichten"
    },
    "quickSearch": "Schnelle Suche",
    "searchFor": "Suche nach {query}",
    "searchForEverything": "Suchen Sie nach allem",
    "searchForEverythingInCollection": "Suchen Sie nach allem in {collection}",
    "searchForEverythingInEntireCollection": "Suchen Sie nach allem in unserer gesamten Sammlung",
    "searchForm": "Suchformular",
    "showSidebar": "Menü anzeigen",
    "sideNavigation": "Seitliche Navigation"
  },
  "homeLinkAlt": "Startseite Europeana",
  "homePage": {
    "discoverEditorial": "Neueste Geschichten",
    "storiesCTA": "Alle Geschichten ansehen",
    "subHeadline": "Suchen, speichern und teilen Sie Kunst, Bücher, Filme und Musik von Tausenden von Kultureinrichtungen",
    "themesCTA": "Alle Themen anzeigen",
    "themesTitle": "Erkunden Sie nach Thema",
    "title": "Entdecken Sie das {digital} kulturelle Erbe Europas",
    "titleDigital": "digitale"
  },
  "imageSlider": {
    "handle": "Schieberegler"
  },
  "items": {
    "itemCount": "1 Objekt |{count} Objekte",
    "itemOf": "{max} von {count} Objekte",
    "recent": "Aktuelle Objekte",
    "recommended": "Empfohlene Objekte",
    "youMightLike": "Objekte, die Ihnen vielleicht gefallen könnten"
  },
  "klaro": {
    "main": {
      "acceptAll": "Alle akzeptieren",
      "acceptSelected": "Ausgewählte akzeptieren",
      "consentModal": {
        "description": "Wir nehmen Ihren Datenschutz ernst. Hier können Sie die Dienste, die wir auf dieser Website nutzen möchten, bewerten und anpassen. Du bist verantwortlich! Aktivieren oder deaktivieren Sie Dienste nach Belieben.",
        "title": "Dienste, die wir gerne nutzen würden."
      },
      "consentNotice": {
        "description": "Wir kümmern uns um Ihre Privatsphäre und verwenden Daten nur, um Ihre Erfahrung zu verbessern. Wir verwenden keine personenbezogenen Daten für Werbung. Sie können Ihre Einwilligung alle 15 Tage ändern.",
        "learnMore": "Lass mich aussuchen"
      },
      "decline": "Ich lehne ab",
      "ok": "Okay",
      "purposes": {
        "essential": {
          "description": "Diese Dienste sind für das korrekte Funktionieren dieser Website unerlässlich. Sie umfassen die Anzeige von Suchergebnissen und Spracheinstellungen, bewahren den eingeloggten Status und sorgen für die Sicherheit Ihres Besuchs. Sie können sie nicht deaktivieren, da die Website sonst nicht richtig funktionieren würde.",
          "title": "Grundlegende Dienste für Sicherheit und Anpassung"
        },
        "usage": {
          "description": "Diese Dienste sammeln die Informationen, um uns zu helfen, besser zu verstehen, wie die Website verwendet wird und wo die Schwachstellen sind, und befähigen uns, fundierte Entscheidungen zu treffen, um Ihre Erfahrung zu verbessern.",
          "title": "Dienste zur Erfassung von Website-Nutzung und Feedback"
        }
      },
      "service": {
        "disableAll": {
          "description": "Verwenden Sie diesen Schalter, um alle optionalen Dienste zu aktivieren oder zu deaktivieren.",
          "title": "Alle Dienste aktivieren oder deaktivieren"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Hilft, unsere Website zu verbessern, indem gelegentlich experimentelle Änderungen vorgenommen werden.",
        "title": "A/B-Tests"
      },
      "auth-strategy": {
        "description": "Erinnert an die Berechtigungsstrategie, die für die Anmeldung verwendet werden soll.",
        "title": "Auth-Strategie"
      },
      "debugSettings": {
        "description": "Hilft beim Debuggen von API-Anfragen",
        "title": "Debug toggle"
      },
      "hotjar": {
        "description": "Aktiviert ein Umfrage-Widget, das Ihnen die Möglichkeit gibt, auf unsere Umfragen zur Besucherzufriedenheit zu antworten.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Merkt sich Ihre bevorzugte Oberflächensprache für den zukünftigen Zugriff.",
        "title": "Sprachcode"
      },
      "jira-servicedesk": {
        "description": "Aktiviert das Feedback-Widget, das Ihnen die Möglichkeit gibt, uns zu kontaktieren.",
        "title": "Jira service desk"
      },
      "matomo": {
        "description": "Sammelt anonyme Statistiken darüber, wie Besucher mit der Website interagieren.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Zeigt eine Benachrichtigung an, wenn neue Funktionen verfügbar sind.",
        "title": "Benachrichtigung über neue Funktionen"
      },
      "searchResultsView": {
        "description": "Merkt sich, ob Sie die Suchergebnisse lieber in einer Listen- oder Rasteransicht anzeigen möchten.",
        "title": "Suchergebnisansicht (Liste/Raster)"
      }
    }
  },
  "layout": {
    "skipToMain": "Direkt zum Seiteninhalt"
  },
  "learnMore": "Erfahren Sie mehr über die Quelle dieser Beschreibung",
  "loading": "Laden",
  "loadingResults": "Ergebnisse werden geladen",
  "messages": {
    "copyToClipboardSuccess": "In die Zwischenablage kopiert",
    "externalContentError": "Der externe Inhalt konnte nicht geladen werden",
    "notFound": "Nicht gefunden",
    "paginationLimitExceeded": "Es können nur die ersten {limit} Suchergebnisse angezeigt werden."
  },
  "modal": {
    "download": {
      "clickToCopy": "Klicken Sie auf die Namensnennung, um sie zu kopieren",
      "modalIntro": "Wenn Sie dieses Objekt im Web oder anderswo verwenden, vergessen Sie nicht, die folgende Attribution daneben anzuzeigen:",
      "modalTitle": "Dank sagen"
    }
  },
  "multilingual": {
    "automated": "Automatisierte Übersetzung",
    "enrichment": "Anreicherung durch Partnerprojekte",
    "other": "anderen Sprachen",
    "stopTranslating": "Beenden Sie die Übersetzung dieses Objektes ins {0}.",
    "translateLanguage": "Möchten Sie dieses Objekt in {0} sehen?",
    "translateQuotaError": "Der Übersetzungsdienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut."
  },
  "newFeatureNotification": {
    "dismiss": "Schließen",
    "readMore": "Mehr anzeigen",
    "text": {
      "searchFilters": "Sie können jetzt nach bestimmten Werten in den Filtern suchen; probieren Sie es aus!"
    }
  },
  "newWindow": "öffnet sich in einem neuen Fenster",
  "noMoreResults": "Es gibt keine weiteren Ergebnisse für Ihre Suchanfrage.",
  "noResults": "Keine Ergebnisse",
  "of": "Von",
  "organisation": {
    "city": "Stadt",
    "country": "Land",
    "englishName": "Englischer Name",
    "nameAcronym": "Name Akronym"
  },
  "pageHasLoaded": "hat geladen",
  "pageNumber": "Seitennummer",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Name"
        },
        "title": "Organisationen"
      },
      "persons": {
        "title": "Personen"
      },
      "places": {
        "title": "Orte"
      },
      "table": {
        "items": "Artikel",
        "name": "Name"
      },
      "times": {
        "title": "Mal"
      },
      "topics": {
        "title": "Themen"
      }
    }
  },
  "pagination": {
    "label": "Paginierung"
  },
  "readMore": "Mehr anzeigen",
  "recommendation": {
    "prompts": {
      "accept": "Daumen hoch zum Hinzufügen zur Galerie",
      "reject": "Daumen runter, wenn es dir nicht gefällt"
    }
  },
  "record": {
    "IIIFViewer": "IIIF-Viewer",
    "actions": {
      "pin": "Objekt an verfügbare Entitäten anheften"
    },
    "allMetaData": "Alle Metadaten",
    "copyEmbedLabel": "Code einbetten (Zum Kopieren klicken)",
    "exploreMore": "Entdecken Sie mehr",
    "extendedInformation": "Erweiterte Informationen",
    "goodToKnow": "Gut zu wissen",
    "hideAll": "Alle Informationen ausblenden",
    "location": "Ort",
    "locationOnMap": "Standort auf der Karte",
    "mediaPlayer": "Media Player",
    "record": "Aufzeichnung",
    "showAll": "Alle Informationen anzeigen",
    "similarItems": "Ähnliche Objekte",
    "status": {
      "unpublished": "[unveröffentlichtes Objekt]"
    },
    "transcription": "Transkription",
    "transcriptionDisclaimer": "Dieser Inhalt wird von der Öffentlichkeit bereitgestellt, nicht von der Institution, die dieses Objekt bereitgestellt hat."
  },
  "related": {
    "editorial": {
      "title": "Geschichten, die Ihnen gefallen könnten"
    }
  },
  "relatedCollections": "Zugehörige Sammlungen",
  "removeFilter": "{filterLabel}-Filter entfernen",
  "reset": "Zurücksetzen",
  "resourceWikimedia": "Ressource aus Wikimedia Commons",
  "results": "Ergebnisse",
  "resultsFor": "Ergebnisse für {0}",
  "resultsLimitWarning": "Zusätzliche Ergebnisse werden nicht angezeigt, da nur die ersten 1000 relevantesten Ergebnisse angezeigt werden. Wenn Sie nicht gefunden haben, wonach Sie suchen, können Sie Ihre Suche verfeinern.",
  "resultsWithin": "Ergebnisse innerhalb {0} {1} für {2}",
  "search": {
    "boost": {
      "placeholder": "Geben Sie die Feldverstärkungsabfrage ein"
    },
    "title": "Suche"
  },
  "searchHasLoaded": "{0} Ergebnisse zurückgegeben",
  "searchPlaceholder": "Suche 50+ Millionen Artikel",
  "searchResults": "Suche",
  "searchResultsFor": "{0} - Suche",
  "searchSuggestions": "Suchvorschläge",
  "searchTier": {
    "button": {
      "hide": "Diese Objekte ausblenden",
      "show": "Diese Objekte anzeigen"
    },
    "text": {
      "hide": "Objekten, die unsere Veröffentlichungskriterien nicht erfüllen, werden angezeigt.",
      "show": "Weitere Objekten entsprechen Ihrer Suche, erfüllen jedoch nicht unsere Veröffentlichungskriterien."
    }
  },
  "searchViews": {
    "grid": "Gitteransicht",
    "list": "Listenansicht",
    "mosaic": "Mosaik-Ansicht"
  },
  "set": {
    "actions": {
      "addTo": "Zur Galerie hinzufügen",
      "create": "Galerie erstellen",
      "createNew": "Neue Galerie erstellen",
      "delete": "Galerie löschen",
      "edit": "Galerie bearbeiten",
      "update": "Galerie aktualisieren"
    },
    "form": {
      "description": "Galeriebeschreibung",
      "private": "Diese Galerie privat halten",
      "required": "Pflichtfeld",
      "title": "Galeriename"
    },
    "labels": {
      "curatedBy": "Kuratiert von",
      "private": "Private Galerie"
    },
    "notifications": {
      "deleted": "Ihre Galerie wurde gelöscht.",
      "likeLimit": {
        "body": "Es tut uns leid, aber Sie können derzeit maximal 100 Objekte liken. Wir werden dieses Limit bald aufheben!",
        "title": "100 Likes"
      },
      "updated": "Das Objekt wurde der Galerie hinzugefügt."
    },
    "prompts": {
      "delete": "Möchten Sie diese Galerie wirklich löschen? Wenn Sie diese Galerie löschen, verlieren Sie alle Objekte, die Sie hinzugefügt haben."
    }
  },
  "showLess": "Weniger anzeigen",
  "showMore": "Mehr anzeigen",
  "sideFilters": {
    "noOptions": "Es sind keine Optionen zur Auswahl verfügbar",
    "search": "Suche"
  },
  "statuses": {
    "liked": "Gemocht",
    "pinned": "Angeheftet"
  },
  "storiesPage": {
    "title": "Geschichten"
  },
  "website": "Webseite",
  "youMightAlsoLike": "Das könnte Ihnen auch gefallen"
};
